



































































































import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { IAction } from "@/components/utility/mmmint/MHeader.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { InvoiceLine } from "@/models/invoice-line.entity";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { WorkshopContractRate } from "@/models/workshop-contract-rate.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import Tooltip from "../utility/tooltip.vue";
import RepairEstimateResponseCardHistory from "./RepairEstimateResponseCardHistory.vue";
import LineItemsForm from "./LineItemsForm.vue";

enum CreateInvoiceWindow {
  FILE = "file",
  FIELDS = "fields"
}

enum ResponseType {
  ACCEPT,
  REQUEST,
  REJECT
}

@Component({
  components: {
    LineItemsForm,
    RepairEstimateResponseCardHistory,
    ConfirmActionDialog,
    DropAreaMulti,
    Tooltip
  },
  filters: { simpleDoubleDigitDate }
})
export default class RepairEstimateResponseCard extends mixins(PermissionMixin, RulesMixin) {
  readonly simpleDoubleDigitDate = simpleDoubleDigitDate;

  readonly getAutocompleteFilter = getAutocompleteFilter;

  readonly CurrencyEnum = CurrencyEnum;

  readonly CreateInvoiceWindow = CreateInvoiceWindow;

  readonly RequestStatusEnum = RequestStatusEnum;

  readonly statusIconMap = RepairEstimate.statusIconMap;

  readonly statusColorMap = RepairEstimate.statusColorMap;

  ResponseType = ResponseType;
  response: ResponseType = ResponseType.ACCEPT;

  @Prop()
  value!: IRepairEstimate;

  @Prop()
  token!: string;

  loadingReject = false;

  loadingRequestMoreData = false;

  loadingRespondReject = false;

  isRejectDialogActive = false;

  isRequestMoreDialogActive = false;

  rejectReason = "";

  requestMoreDataReason = "";

  get actions(): IAction[] {
    const actions: IAction[] = [];
    actions.push({
      text: $t("repairEstimate.response.makeOffer"),
      icon: RepairEstimate.statusIconMap.get(RequestStatusEnum.ACCEPTED),
      color: RepairEstimate.statusColorMap.get(RequestStatusEnum.ACCEPTED),
      loading: this.loading,
      exec: () => (this.isDialogActive = true),
      key: "makeOffer"
    });

    actions.push({
      text: $t("repairEstimate.response.requestMore"),
      icon: RepairEstimate.statusIconMap.get(RequestStatusEnum.REQUEST_MORE_DATA),
      color: RepairEstimate.statusColorMap.get(RequestStatusEnum.REQUEST_MORE_DATA),
      loading: this.loadingRequestMoreData,
      exec: () => (this.isRequestMoreDialogActive = true),
      key: "requestMore"
    });

    actions.push({
      text: $t("repairEstimate.response.reject"),
      icon: RepairEstimate.statusIconMap.get(RequestStatusEnum.REJECTED_BY_REQUESTED),
      color: RepairEstimate.statusColorMap.get(RequestStatusEnum.REJECTED_BY_REQUESTED),
      loading: this.loadingRespondReject,
      exec: () => (this.isRejectDialogActive = true),
      key: "reject"
    });

    return actions;
  }

  step = CreateInvoiceWindow.FILE;

  valueCopy = new RepairEstimate(this.value);

  isDialogActive = false;

  loading = false;

  isValid = false;

  file: File | null = null;

  reason = "";

  get leftText(): string {
    switch (this.step) {
      case CreateInvoiceWindow.FILE:
        return $t("close");
      case CreateInvoiceWindow.FIELDS:
        return $t("back");
      default:
        return "";
    }
  }

  get rightText(): string {
    switch (this.step) {
      case CreateInvoiceWindow.FILE:
        switch (this.response) {
          case ResponseType.ACCEPT:
            return $t("next");

          case ResponseType.REQUEST:
            return $t("repairEstimate.response.confirmOffer");
          case ResponseType.REJECT:
            return $t("repairEstimate.response.confirmOffer");

          default:
            return $t("next");
        }

      case CreateInvoiceWindow.FIELDS:
        return $t("repairEstimate.response.confirmOffer");
      default:
        return "";
    }
  }

  get hideRight() {
    switch (this.step) {
      case CreateInvoiceWindow.FILE:
        switch (this.response) {
          case ResponseType.ACCEPT:
            return true;
          default:
            return false;
        }

      case CreateInvoiceWindow.FIELDS:
        return false;
      default:
        return false;
    }
  }

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  open() {
    this.valueCopy = new RepairEstimate(this.value);
    this.valueCopy.lineItems = [
      new InvoiceLine({ title: this.$t("components.RepairEstimateResponseCard.defaultPosition").toString() })
    ];

    if (!this.valueCopy.workshopRate) {
      this.valueCopy.workshopRate = new WorkshopContractRate();
    }

    this.step = CreateInvoiceWindow.FILE;

    this.isDialogActive = true;
  }

  close() {
    this.isDialogActive = false;
    this.isRejectDialogActive = false;
    this.isRequestMoreDialogActive = false;
  }

  rightClick() {
    if (this.step == CreateInvoiceWindow.FILE) {
      if (this.response === ResponseType.REJECT) {
        return this.respondReject();
      } else if (this.response === ResponseType.REQUEST) {
        return this.respondRequestMoreData();
      } else {
        this.step = CreateInvoiceWindow.FIELDS;
      }
    }

    if (this.step == CreateInvoiceWindow.FIELDS) {
      return this.confirmRepairEstimateResponse();
    }
  }

  leftClick() {
    switch (this.step) {
      case CreateInvoiceWindow.FILE:
        this.close();
        break;
      case CreateInvoiceWindow.FIELDS:
        this.step = CreateInvoiceWindow.FILE;
        break;
    }
  }

  async confirmRepairEstimateResponse() {
    if (!this.file || !this.valueCopy.number || !this.valueCopy.totalNet) {
      this.$toast.error(this.$t("repairEstimate.response.missingFields"));
      return;
    }

    this.loading = true;
    try {
      await this.value.respondAccept(this.token, {
        lineItems: this.valueCopy.lineItems,
        number: this.valueCopy.number,
        file: this.file,
        currency: this.valueCopy.currency as CurrencyEnum
      });

      this.$toast.success(this.$t("repairEstimate.response.success"));
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
      this.close();
    }
  }

  async respondRequestMoreData() {
    this.loadingRequestMoreData = true;
    try {
      await this.value.respondReject(this.token, {
        status: RequestStatusEnum.REQUEST_MORE_DATA,
        message: this.requestMoreDataReason || undefined
      });
    } catch (error) {
      handleError(error);
    } finally {
      this.$toast.success(this.$t("repairEstimate.response.successReject"));
      this.loadingRequestMoreData = false;
      this.close();
    }
  }

  async respondReject() {
    this.loadingReject = true;
    try {
      await this.value.respondReject(this.token, {
        status: RequestStatusEnum.REJECTED_BY_REQUESTED,
        message: this.rejectReason || undefined
      });
    } catch (error) {
      handleError(error);
    } finally {
      this.$toast.success(this.$t("repairEstimate.response.successReject"));
      this.loadingReject = false;
      this.close();
    }
  }

  @Watch("file", { deep: true })
  onFileChange(file: File) {
    if (file && file.name.endsWith(".pdf") && !this.valueCopy.number) {
      this.valueCopy.number = file.name
        .substring(0, file.name.length - 4)
        .replace(/\s+/g, "") // Remove whitespaces
        .replace(/[^\w\d-]/g, ""); // Remove special characters except alphanumeric and hyphen
      this.step = CreateInvoiceWindow.FIELDS;
      this.$nextTick(() => {
        (this.$refs.startField as HTMLInputElement)?.focus();
      });
    }
  }
}
